import { client } from '@/common-utils/libraries/axios/axios';
import { PLANS } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationDeleteAllowedClient = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, planId, allowedClientId }) => {
            return client.delete(replaceParameters(PLANS.PLAN_ALLOWED_CLIENT_DETAILS.url,
                {
                    organizationId: organizationId,
                    planId: planId,
                    allowedClientId: allowedClientId
                }
            ));
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationDeleteAllowedClient;